import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import UserAgentMixin from '../helpers/mixins/UserAgentMixin';
import PlanDetails from './Plans.vue';
let FreePlansDialog = class FreePlansDialog extends Mixins(ViewportSizeMixin, UserAgentMixin) {
};
__decorate([
    Prop({ type: Boolean, default: false })
], FreePlansDialog.prototype, "value", void 0);
FreePlansDialog = __decorate([
    Component({
        components: { PlanDetails },
    })
], FreePlansDialog);
export default FreePlansDialog;
